module.exports = (parcelRequire.load("4dkd1")).then(() => parcelRequire('cO27o'));